import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'semantic-ui-react';

import { LoadingBar, Pagination } from 'components/Commons';
import { PushMessageList, PushMessageModal } from 'components/PushMessage';

import * as com_action from 'actions/company';
import cm from 'helpers/commons';

class PushMessage extends Component {
  constructor() {
    super();

    this.state = {
      //list
      page: 1,
      pagerow: 15,
      //modal
      open: false
    };
  }

  componentWillMount() {
    this.pushList();
  }

  componentDidMount() {
    cm.mainTitle('사용자 푸시메세지 전송');
  }

  pushList = () => {
    const { comAPI } = this.props;
    const { page, pagerow } = this.state;

    const params = {
      page: page,
      pagerow: pagerow
    };
    comAPI.pushList(params);
  };

  pageClick = async (page) => {
    await this.setState({ page: page });
    this.pushList();
  };

  //modal open
  showModal = () => {
    this.setState({
      open: true
    });
  };

  // modal Close
  closeModal = () => {
    this.setState({
      open: false
    });

    this.pushList();
  };

  render() {
    const { page, pagerow, open, dimmer } = this.state,
      { list } = this.props,
      listFn = {
        page: page,
        pagerow: pagerow,
        pageClick: this.pageClick
      },
      modalFn = {
        open: open,
        closeModal: this.closeModal
      };

    let loading = '';
    if (!list) {
      loading = <LoadingBar />;
    }

    return (
      <main>
        {loading}
        <div className="top-btn button">
          <Button.Group>
            <Button inverted color="green" onClick={this.showModal}>
              푸시 등록하기
            </Button>
          </Button.Group>
        </div>

        <PushMessageList listFn={listFn} modalFn={modalFn} />

        <PushMessageModal modalFn={modalFn} />
      </main>
    );
  }
}

PushMessage = connect(
  (state) => ({
    list: state.company.list,
    add: state.company.add
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        pushList: com_action.PushMessageList
      },
      dispatch
    )
  })
)(PushMessage);

export default PushMessage;
